import { render, staticRenderFns } from "./BackgroundSettingsModal.vue?vue&type=template&id=875ff064&"
import script from "./BackgroundSettingsModal.vue?vue&type=script&lang=js&"
export * from "./BackgroundSettingsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports